module.exports = __webpack_public_path__ + "media/apps/app-download-m-phone-3aad5991.jpg";